import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatAccountLanguage',
  standalone: true,
})
export class FormatAccountLanguage implements PipeTransform {
  transform(lang: string): string {
    switch (lang) {
      case 'it':
        return 'Italiano';
      case 'en':
        return 'English';
      case 'de':
        return 'Deutsch';
      case 'fr':
        return 'Français';
      default:
        return '';
    }
  }
}
